var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[(_vm.files.length > 0)?_c('MultipleFileUploadList',{staticClass:"mb-4",attrs:{"files":_vm.files,"disabled":_vm.processing},on:{"order":function($event){return _vm.$emit('input', $event)},"delete":function($event){_vm.$emit(
        'input',
        _vm.files.filter((item) => item != $event)
      )}}}):_vm._e(),_c('FileUploadInput',{attrs:{"label":_vm.label,"multiple":true},on:{"change":_vm.updateFiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }